import { api } from '.';

import { ApiRoutes } from '@/constant/api';

import {
	BookingObjectTypeRequestType,
	BookingObjectTypeResponseType,
} from '@/types/booking-object-types';

const bookingObjectTypesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTypes: builder.query<BookingObjectTypeResponseType, string>({
			query: () => ({
				url: ApiRoutes.BookingObjectTypes,
			}),
			providesTags: ['BookingObjectTypes'],
		}),
		createType: builder.mutation<null, BookingObjectTypeRequestType>({
			query: (body) => ({
				url: ApiRoutes.BookingObjectTypes,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['BookingObjectTypes'],
		}),
		updateType: builder.mutation<null, BookingObjectTypeRequestType>({
			query: (body) => ({
				url: `${ApiRoutes.BookingObjectTypes}/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['BookingObjectTypes'],
		}),
		deleteType: builder.mutation<null, number>({
			query: (id) => ({
				url: `${ApiRoutes.BookingObjectTypes}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['BookingObjectTypes'],
		}),
	}),
});

export const {
	useGetTypesQuery,
	useCreateTypeMutation,
	useUpdateTypeMutation,
	useDeleteTypeMutation,
} = bookingObjectTypesApi;
